<form [formGroup]="form" class="n-form">
  <lib-form-field
    [label]="'BARDO_SERVICOS.NOME_CAMPO' | translate: { termo: $nicho().servico.singular }"
    controlName="nome"
    [required]="true"
    [maxLength]="50"
  >
    <input
      pInputText
      formControlName="nome"
      [placeholder]="'BARDO_SERVICOS.NOME_CAMPO_PLACEHOLDER' | translate: { termo: ($nicho().servico.singular | lowercase) }"
      maxlength="50"
    />
  </lib-form-field>


  <div class="n-field-row">
    <lib-form-field
      [label]="'BARDO_SERVICOS.DURACAO' | translate"
      controlName="duracaoTime"
      [required]="true"
      [helpText]="
        'BARDO_SERVICOS.MAXIMO' | translate: { tempo: formatarDuracaoExibicao(duracaoMaximaMinutos()) }
      "
    >
      <p-datepicker
        formControlName="duracaoTime"
        [timeOnly]="true"
        [showTime]="true"
        [readonlyInput]="true"
        [showIcon]="true"
        [iconDisplay]="'input'"
        hourFormat="24"
        stepMinute="5"
        [maxDate]="duracaoMaximaDate()"
        placeholder="00:30"
        appendTo="body"
      />
    </lib-form-field>

    <lib-form-field [label]="'GLOBAL.VALOR' | translate" controlName="valor" [required]="false">
      <p-inputGroup>
        <p-inputGroupAddon>{{ simboloMoeda() }}</p-inputGroupAddon>
        <p-inputNumber
          formControlName="valor"
          placeholder="0,00"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
        />
      </p-inputGroup>
    </lib-form-field>
  </div>
</form>
